import { render, staticRenderFns } from "./Orderpay.vue?vue&type=template&id=209c3004&scoped=true&"
import script from "./Orderpay.vue?vue&type=script&lang=js&"
export * from "./Orderpay.vue?vue&type=script&lang=js&"
import style0 from "./Orderpay.vue?vue&type=style&index=0&id=209c3004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c3004",
  null
  
)

export default component.exports